import _ from 'lodash';
import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	const statuses = _.orderBy(data, [(status) => status.toLowerCase()]);
	const mapOptionValues = statuses.map((s) => ({
		value: s,
		label: s,
		isChecked: false,
	}));

	return { statuses: mapOptionValues };
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
});
